/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTapioAddCardPost$Json } from '../fn/tapio/api-tapio-add-card-post-json';
import { ApiTapioAddCardPost$Json$Params } from '../fn/tapio/api-tapio-add-card-post-json';
import { apiTapioAddCardPost$Plain } from '../fn/tapio/api-tapio-add-card-post-plain';
import { ApiTapioAddCardPost$Plain$Params } from '../fn/tapio/api-tapio-add-card-post-plain';
import { apiTapioGetAllCardByEntityPaged2Get$Json } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-2-get-json';
import { ApiTapioGetAllCardByEntityPaged2Get$Json$Params } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-2-get-json';
import { apiTapioGetAllCardByEntityPaged2Get$Plain } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-2-get-plain';
import { ApiTapioGetAllCardByEntityPaged2Get$Plain$Params } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-2-get-plain';
import { apiTapioGetAllCardByEntityPagedGet$Json } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-get-json';
import { ApiTapioGetAllCardByEntityPagedGet$Json$Params } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-get-json';
import { apiTapioGetAllCardByEntityPagedGet$Plain } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-get-plain';
import { ApiTapioGetAllCardByEntityPagedGet$Plain$Params } from '../fn/tapio/api-tapio-get-all-card-by-entity-paged-get-plain';
import { apiTapioGetCardDetailsGet$Json } from '../fn/tapio/api-tapio-get-card-details-get-json';
import { ApiTapioGetCardDetailsGet$Json$Params } from '../fn/tapio/api-tapio-get-card-details-get-json';
import { apiTapioGetCardDetailsGet$Plain } from '../fn/tapio/api-tapio-get-card-details-get-plain';
import { ApiTapioGetCardDetailsGet$Plain$Params } from '../fn/tapio/api-tapio-get-card-details-get-plain';
import { apiTapioGetCardsByEntityIdGet$Json } from '../fn/tapio/api-tapio-get-cards-by-entity-id-get-json';
import { ApiTapioGetCardsByEntityIdGet$Json$Params } from '../fn/tapio/api-tapio-get-cards-by-entity-id-get-json';
import { apiTapioGetCardsByEntityIdGet$Plain } from '../fn/tapio/api-tapio-get-cards-by-entity-id-get-plain';
import { ApiTapioGetCardsByEntityIdGet$Plain$Params } from '../fn/tapio/api-tapio-get-cards-by-entity-id-get-plain';
import { apiTapioGetClientInfoGet$Json } from '../fn/tapio/api-tapio-get-client-info-get-json';
import { ApiTapioGetClientInfoGet$Json$Params } from '../fn/tapio/api-tapio-get-client-info-get-json';
import { apiTapioGetClientInfoGet$Plain } from '../fn/tapio/api-tapio-get-client-info-get-plain';
import { ApiTapioGetClientInfoGet$Plain$Params } from '../fn/tapio/api-tapio-get-client-info-get-plain';
import { apiTapioGetDtrLogsByDatePagedGet$Json } from '../fn/tapio/api-tapio-get-dtr-logs-by-date-paged-get-json';
import { ApiTapioGetDtrLogsByDatePagedGet$Json$Params } from '../fn/tapio/api-tapio-get-dtr-logs-by-date-paged-get-json';
import { apiTapioGetDtrLogsByDatePagedGet$Plain } from '../fn/tapio/api-tapio-get-dtr-logs-by-date-paged-get-plain';
import { ApiTapioGetDtrLogsByDatePagedGet$Plain$Params } from '../fn/tapio/api-tapio-get-dtr-logs-by-date-paged-get-plain';
import { apiTapioSearchUserGet$Json } from '../fn/tapio/api-tapio-search-user-get-json';
import { ApiTapioSearchUserGet$Json$Params } from '../fn/tapio/api-tapio-search-user-get-json';
import { apiTapioSearchUserGet$Plain } from '../fn/tapio/api-tapio-search-user-get-plain';
import { ApiTapioSearchUserGet$Plain$Params } from '../fn/tapio/api-tapio-search-user-get-plain';
import { apiTapioUpdateCardPost$Json } from '../fn/tapio/api-tapio-update-card-post-json';
import { ApiTapioUpdateCardPost$Json$Params } from '../fn/tapio/api-tapio-update-card-post-json';
import { apiTapioUpdateCardPost$Plain } from '../fn/tapio/api-tapio-update-card-post-plain';
import { ApiTapioUpdateCardPost$Plain$Params } from '../fn/tapio/api-tapio-update-card-post-plain';
import { apiTapioUploadDtrLogsPost$Json } from '../fn/tapio/api-tapio-upload-dtr-logs-post-json';
import { ApiTapioUploadDtrLogsPost$Json$Params } from '../fn/tapio/api-tapio-upload-dtr-logs-post-json';
import { apiTapioUploadDtrLogsPost$Plain } from '../fn/tapio/api-tapio-upload-dtr-logs-post-plain';
import { ApiTapioUploadDtrLogsPost$Plain$Params } from '../fn/tapio/api-tapio-upload-dtr-logs-post-plain';
import { CardUser } from '../models/card-user';
import { ClientDetails } from '../models/client-details';
import { DtrLogWithInfo } from '../models/dtr-log-with-info';
import { Entity } from '../models/entity';
import { LogCard } from '../models/log-card';
import { SimplifiedEntity } from '../models/simplified-entity';

@Injectable({ providedIn: 'root' })
export class TapioService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTapioGetCardsByEntityIdGet()` */
  static readonly ApiTapioGetCardsByEntityIdGetPath = '/api/Tapio/getCardsByEntityId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardsByEntityIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Plain$Response(params?: ApiTapioGetCardsByEntityIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LogCard>>> {
    return apiTapioGetCardsByEntityIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardsByEntityIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Plain(params?: ApiTapioGetCardsByEntityIdGet$Plain$Params, context?: HttpContext): Observable<Array<LogCard>> {
    return this.apiTapioGetCardsByEntityIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LogCard>>): Array<LogCard> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardsByEntityIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Json$Response(params?: ApiTapioGetCardsByEntityIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LogCard>>> {
    return apiTapioGetCardsByEntityIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardsByEntityIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Json(params?: ApiTapioGetCardsByEntityIdGet$Json$Params, context?: HttpContext): Observable<Array<LogCard>> {
    return this.apiTapioGetCardsByEntityIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LogCard>>): Array<LogCard> => r.body)
    );
  }

  /** Path part for operation `apiTapioGetAllCardByEntityPagedGet()` */
  static readonly ApiTapioGetAllCardByEntityPagedGetPath = '/api/Tapio/GetAllCardByEntityPaged';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPagedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Plain$Response(params?: ApiTapioGetAllCardByEntityPagedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {
    return apiTapioGetAllCardByEntityPagedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPagedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Plain(params?: ApiTapioGetAllCardByEntityPagedGet$Plain$Params, context?: HttpContext): Observable<Array<SimplifiedEntity>> {
    return this.apiTapioGetAllCardByEntityPagedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>): Array<SimplifiedEntity> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPagedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Json$Response(params?: ApiTapioGetAllCardByEntityPagedGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {
    return apiTapioGetAllCardByEntityPagedGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPagedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Json(params?: ApiTapioGetAllCardByEntityPagedGet$Json$Params, context?: HttpContext): Observable<Array<SimplifiedEntity>> {
    return this.apiTapioGetAllCardByEntityPagedGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>): Array<SimplifiedEntity> => r.body)
    );
  }

  /** Path part for operation `apiTapioGetAllCardByEntityPaged2Get()` */
  static readonly ApiTapioGetAllCardByEntityPaged2GetPath = '/api/Tapio/GetAllCardByEntityPaged2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPaged2Get$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Plain$Response(params?: ApiTapioGetAllCardByEntityPaged2Get$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {
    return apiTapioGetAllCardByEntityPaged2Get$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPaged2Get$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Plain(params?: ApiTapioGetAllCardByEntityPaged2Get$Plain$Params, context?: HttpContext): Observable<Array<SimplifiedEntity>> {
    return this.apiTapioGetAllCardByEntityPaged2Get$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>): Array<SimplifiedEntity> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPaged2Get$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Json$Response(params?: ApiTapioGetAllCardByEntityPaged2Get$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {
    return apiTapioGetAllCardByEntityPaged2Get$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPaged2Get$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Json(params?: ApiTapioGetAllCardByEntityPaged2Get$Json$Params, context?: HttpContext): Observable<Array<SimplifiedEntity>> {
    return this.apiTapioGetAllCardByEntityPaged2Get$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>): Array<SimplifiedEntity> => r.body)
    );
  }

  /** Path part for operation `apiTapioGetCardDetailsGet()` */
  static readonly ApiTapioGetCardDetailsGetPath = '/api/Tapio/GetCardDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardDetailsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Plain$Response(params?: ApiTapioGetCardDetailsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CardUser>> {
    return apiTapioGetCardDetailsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardDetailsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Plain(params?: ApiTapioGetCardDetailsGet$Plain$Params, context?: HttpContext): Observable<CardUser> {
    return this.apiTapioGetCardDetailsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CardUser>): CardUser => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardDetailsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Json$Response(params?: ApiTapioGetCardDetailsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CardUser>> {
    return apiTapioGetCardDetailsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardDetailsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Json(params?: ApiTapioGetCardDetailsGet$Json$Params, context?: HttpContext): Observable<CardUser> {
    return this.apiTapioGetCardDetailsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CardUser>): CardUser => r.body)
    );
  }

  /** Path part for operation `apiTapioGetDtrLogsByDatePagedGet()` */
  static readonly ApiTapioGetDtrLogsByDatePagedGetPath = '/api/Tapio/GetDtrLogsByDatePaged';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetDtrLogsByDatePagedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Plain$Response(params?: ApiTapioGetDtrLogsByDatePagedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DtrLogWithInfo>>> {
    return apiTapioGetDtrLogsByDatePagedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetDtrLogsByDatePagedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Plain(params?: ApiTapioGetDtrLogsByDatePagedGet$Plain$Params, context?: HttpContext): Observable<Array<DtrLogWithInfo>> {
    return this.apiTapioGetDtrLogsByDatePagedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DtrLogWithInfo>>): Array<DtrLogWithInfo> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetDtrLogsByDatePagedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Json$Response(params?: ApiTapioGetDtrLogsByDatePagedGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DtrLogWithInfo>>> {
    return apiTapioGetDtrLogsByDatePagedGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetDtrLogsByDatePagedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Json(params?: ApiTapioGetDtrLogsByDatePagedGet$Json$Params, context?: HttpContext): Observable<Array<DtrLogWithInfo>> {
    return this.apiTapioGetDtrLogsByDatePagedGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DtrLogWithInfo>>): Array<DtrLogWithInfo> => r.body)
    );
  }

  /** Path part for operation `apiTapioSearchUserGet()` */
  static readonly ApiTapioSearchUserGetPath = '/api/Tapio/SearchUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioSearchUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Plain$Response(params?: ApiTapioSearchUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Entity>>> {
    return apiTapioSearchUserGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioSearchUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Plain(params?: ApiTapioSearchUserGet$Plain$Params, context?: HttpContext): Observable<Array<Entity>> {
    return this.apiTapioSearchUserGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Entity>>): Array<Entity> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioSearchUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Json$Response(params?: ApiTapioSearchUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Entity>>> {
    return apiTapioSearchUserGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioSearchUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Json(params?: ApiTapioSearchUserGet$Json$Params, context?: HttpContext): Observable<Array<Entity>> {
    return this.apiTapioSearchUserGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Entity>>): Array<Entity> => r.body)
    );
  }

  /** Path part for operation `apiTapioGetClientInfoGet()` */
  static readonly ApiTapioGetClientInfoGetPath = '/api/Tapio/GetClientInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetClientInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Plain$Response(params?: ApiTapioGetClientInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDetails>> {
    return apiTapioGetClientInfoGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetClientInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Plain(params?: ApiTapioGetClientInfoGet$Plain$Params, context?: HttpContext): Observable<ClientDetails> {
    return this.apiTapioGetClientInfoGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientDetails>): ClientDetails => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetClientInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Json$Response(params?: ApiTapioGetClientInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDetails>> {
    return apiTapioGetClientInfoGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetClientInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Json(params?: ApiTapioGetClientInfoGet$Json$Params, context?: HttpContext): Observable<ClientDetails> {
    return this.apiTapioGetClientInfoGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientDetails>): ClientDetails => r.body)
    );
  }

  /** Path part for operation `apiTapioAddCardPost()` */
  static readonly ApiTapioAddCardPostPath = '/api/Tapio/AddCard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioAddCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Plain$Response(params?: ApiTapioAddCardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioAddCardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioAddCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Plain(params?: ApiTapioAddCardPost$Plain$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioAddCardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioAddCardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Json$Response(params?: ApiTapioAddCardPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioAddCardPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioAddCardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Json(params?: ApiTapioAddCardPost$Json$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioAddCardPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `apiTapioUpdateCardPost()` */
  static readonly ApiTapioUpdateCardPostPath = '/api/Tapio/UpdateCard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUpdateCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Plain$Response(params?: ApiTapioUpdateCardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioUpdateCardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioUpdateCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Plain(params?: ApiTapioUpdateCardPost$Plain$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioUpdateCardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUpdateCardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Json$Response(params?: ApiTapioUpdateCardPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioUpdateCardPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioUpdateCardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Json(params?: ApiTapioUpdateCardPost$Json$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioUpdateCardPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `apiTapioUploadDtrLogsPost()` */
  static readonly ApiTapioUploadDtrLogsPostPath = '/api/Tapio/UploadDtrLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUploadDtrLogsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Plain$Response(params?: ApiTapioUploadDtrLogsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioUploadDtrLogsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioUploadDtrLogsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Plain(params?: ApiTapioUploadDtrLogsPost$Plain$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioUploadDtrLogsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUploadDtrLogsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Json$Response(params?: ApiTapioUploadDtrLogsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiTapioUploadDtrLogsPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTapioUploadDtrLogsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Json(params?: ApiTapioUploadDtrLogsPost$Json$Params, context?: HttpContext): Observable<number> {
    return this.apiTapioUploadDtrLogsPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
